module.exports = __webpack_public_path__ + "static/index/img/baikal-402.e279b188.jpg";